import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Orbitas keeps Atomic CRM's business logic while the presentation layer is
 * progressively migrated to IBM Carbon Design System.
 */
const App = () => <CRM title="Orbitas" disableTelemetry />;

export default App;
